<script lang="ts">
	import { format } from 'svelte-i18n';
	import { ListItem, HeroValue, Text } from '@Shelly/shelly-design-system';
	import SidepanelPeekTray from 'src/components/Sidepanel/SidepanelPeekTray.svelte';
	import {
		getSidepanelStatusTitle,
		getSidepanelStatusValue,
		type SidepanelStatusItem,
	} from 'src/helpers/sidepanel_status_slots';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';

	export let main: SidepanelStatusItem | null = null;
	export let peek: SidepanelStatusItem[] = [];
	/** When false, the caller renders the main status elsewhere (e.g. centered Avatar). */
	export let showMain = true;
	export let expanded = false;
	/** Show the PeekTray even when peek is empty (e.g. last reporter only). */
	export let forcePeekTray = false;

	let className = '';
	export { className as class };

	$: showMainContainer = showMain && !!main;
	$: showPeekTray = peek.length > 0 || forcePeekTray;
	$: mainTitle = getSidepanelStatusTitle(main);
	$: mainValue = getSidepanelStatusValue(main);
</script>

{#if showMainContainer || showPeekTray}
	<div class="sidepanel-status-peek {className}">
		{#if showMainContainer}
			<div class="sidepanel-status-peek__main">
				<HeroValue layout="stacked" size="l" label={mainTitle} value={mainValue} />
			</div>
		{/if}

		{#if showPeekTray}
			<SidepanelPeekTray
				class="sidepanel-status-peek__tray"
				bind:expanded
				expandLabel={$format('label_peek_tray_expand_labels', {
					default: 'Show device details',
				})}
				collapseLabel={$format('label_peek_tray_collapse_labels', {
					default: 'Hide device details',
				})}
			>
				<svelte:fragment slot="peek">
					<Text styleType="miniature" class="text-color-muted text-center">
						{$format('label_peek_tray_details', { default: 'Details' })}
					</Text>
				</svelte:fragment>
				<!-- Vertical list: d-flex flex-direction-column. Not Stack, not LabelListV2. -->
				<div class="d-flex flex-direction-column width-full gap-xs">
					{#each peek as item (item.name || item.role)}
						<ListItem
							class="width-full"
							viewType="default"
							icon={mapIconSolidWeightToLight(item.icon || '')}
							title={getSidepanelStatusTitle(item)}
							extraText={{ title: getSidepanelStatusValue(item) }}
						/>
					{/each}
					<slot name="trayExtra" />
				</div>
			</SidepanelPeekTray>
		{/if}
	</div>
{/if}

<style>
	.sidepanel-status-peek {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.sidepanel-status-peek__main {
		position: relative;
		z-index: 0;
		padding-bottom: 20px;
		margin-bottom: -12px;
	}

	.sidepanel-status-peek :global(.sidepanel-peek-tray) {
		position: relative;
		z-index: 1;
	}

	.sidepanel-status-peek :global(.sidepanel-peek-tray__body) {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		width: 100%;
	}

	.sidepanel-status-peek :global(.list-item) {
		flex: 0 0 auto;
		width: 100%;
	}
</style>
